var refs = 0;
var dispose;
var content = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?outputStyle=expanded!./ProductsTable.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
exports.use = exports.ref = function() {
	if(!(refs++)) {
		exports.locals = content.locals;
		dispose = require("!../../../../node_modules/style-loader/addStyles.js")(content);
	}
	return exports;
};
exports.unuse = exports.unref = function() {
	if(!(--refs)) {
		dispose();
		dispose = null;
	}
};
if(module.hot) {
	var lastRefs = module.hot.data && module.hot.data.refs || 0;
	if(lastRefs) {
		exports.ref();
		if(!content.locals) {
			refs = lastRefs;
		}
	}
	if(!content.locals) {
		module.hot.accept();
	}
	module.hot.dispose(function(data) {
		data.refs = content.locals ? 0 : refs;
		if(dispose) {
			dispose();
		}
	});
}


//////////////////
// WEBPACK FOOTER
// /src/components/Product/ProductsTable/ProductsTable.scss
// module id = 1958
// module chunks = 0